import { useState, useMemo } from "react";
import { Search, X } from "lucide-react";

const BOX = "w-full rounded-2xl bg-background px-3 py-2.5 text-sm shadow-neu-sm";

// مربع بحث عن شركة بالاسم من جميع الشركات المشتركة؛ عند الاختيار يُرسَل الإشعار لها مباشرة.
export const CompanyPicker = ({ companies = [], value, onChange }) => {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const selected = companies.find((c) => c.id === value);
  const list = useMemo(() => {
    const t = q.trim().toLowerCase();
    const src = companies.filter((c) => `${c.name || ""} ${c.nickname || ""}`.toLowerCase().includes(t));
    return (t ? src : companies).slice(0, 10);
  }, [q, companies]);
  if (selected) {
    return (
      <div className="flex items-center justify-between rounded-2xl bg-primary/10 px-3 py-2.5 text-sm font-bold" data-testid="notify-company-selected">
        <span>إرسال مباشر إلى: {selected.nickname || selected.name}</span>
        <button type="button" data-testid="notify-company-clear" aria-label="إلغاء" onClick={() => { onChange(""); setQ(""); }}>
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }
  return (
    <div className="relative">
      <div className="flex items-center gap-2 rounded-2xl bg-background px-2 shadow-neu-sm">
        <Search className="h-4 w-4 shrink-0 text-muted-foreground" />
        <input data-testid="notify-company-search" className={`${BOX} !shadow-none`} placeholder="ابحث عن شركة بالاسم للإرسال المباشر…"
          value={q} onChange={(e) => { setQ(e.target.value); setOpen(true); }} onFocus={() => setOpen(true)} />
      </div>
      {open && list.length ? (
        <ul className="absolute z-20 mt-1 max-h-56 w-full overflow-auto rounded-2xl bg-background p-1 shadow-neu" data-testid="notify-company-list">
          {list.map((c) => (
            <li key={c.id}>
              <button type="button" data-testid={`notify-company-opt-${c.id}`} onMouseDown={() => { onChange(c.id); setOpen(false); }}
                className="w-full rounded-xl px-3 py-2 text-start text-sm font-semibold hover:bg-primary/10">
                {c.nickname || c.name}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
};
